import { IntlShape } from "react-intl";

type FormatDateType = Parameters<Intl.DateTimeFormat["format"]>[0] | string;
export const formatDateMonthYear = (intl: IntlShape) => (value: FormatDateType) =>
    intl.formatDate(value, {
        year:  "numeric",
        month: "short",
    });

export const formatDateDayMonthYear = (intl: IntlShape) => (value: FormatDateType) =>
intl.formatDate(value, {
    year:  "numeric",
    month: "numeric",
    day:   "numeric",
});
